<template>
    <!-- card mode -->
    <v-card class="roma-card full-h" v-if="gridLesson">
        <v-card-text class="full-h">
            <v-container fluid class="pa-0 full-h roma-card__custom-container">
                <v-row class="align-center" no-gutters="">
                    <!-- subject | grade -->
                    <v-col>
                        <p class="roma-card__header text-capitalize">
                            <span class="roma-card__header">{{
                                parserTitleSubject
                            }}</span>
                            <span class="roma-card__grade">
                                {{ lesson.section.nameAndCategoryName }}
                            </span>
                            <span v-if="lesson.basicState == 'INACTIVO'"
                                :class="
                                    'roma-card__state ' +
                                        (lesson.basicState == 'ACTIVO'
                                            ? 'green--text'
                                            : 'red--text')
                                "
                            >
                                {{
                                    lesson.basicState == "ACTIVO"
                                        ? ""
                                        : "INACTIVA"
                                }}
                            </span>

                            <span
                                v-if="lesson.state == 'PUBLICADO' || lesson.state == 'CERRADO'"
                                class="roma-card__lesson_state"
                            >
                                {{ lesson.state == "PUBLICADO" ? "PUBLICADA" : '' }} 

                                {{ lesson.state == "CERRADO" ? "FINALIZADA" : '' }}
                                
                            </span>

                            <span
                                v-if="lesson.editState == 'EN_EDICION'"
                                class="roma-card__lesson_edit_state"
                            >
                                {{ lesson.editState == "EN_EDICION" ? "EDITANDO" : '' }} 
                                
                            </span>
                        </p>
                    </v-col>
                    <v-col cols="1" class="dropdown-wrapper">
                        <RomaOptionsDropdown
                            :options="dropDownOptions"
                            class="card-dropdown"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters="">
                    <v-col>
                        <!-- Pie -->
                        <p class="roma-card__sub-header">
                            {{ lesson.unit.name }}
                            <span v-if="lesson.pie">Pie</span>
                        </p>
                        <!-- code -->
                        <p class="roma-card__pre-title" :title="lesson.title">
                            {{ lesson.code }}
                        </p></v-col
                    >
                </v-row>
                <v-row no-gutters>
                    <v-col>
                        <router-link
                            :to="{
                                name: 'LessonDetail',
                                params: { id: lesson.lessonId }
                            }"
                        >
                            <!-- title -->
                            <div>
                                <span
                                    class="cardTitle--text font-weight-regular roma-card__title mb-3"
                                    :title="lesson.title"
                                    >{{ lesson.title }}</span
                                >
                            </div>
                        </router-link>
                    </v-col>
                </v-row>
                <v-row no-gutters class="align-end align-sm-start">
                    <!-- icon download -->
                    <!-- <v-col class="d-block d-sm-none">
                        <v-btn fab icon small>
                            <v-icon>icon-download</v-icon>
                        </v-btn>
                    </v-col> -->
                    <!-- date -->
                    <!-- <v-col cols="auto" class="d-none d-sm-block">
                        <p class="roma-card__date">
                            {{ parseDate }}
                        </p>
                    </v-col> -->
                    <!-- state -->
                    <!-- <v-col class="text-center d-none d-sm-block">
                        <p class="accent--text roma-card__state">
                            {{ getState }}
                        </p>
                    </v-col> -->
                    <v-col class="d-flex justify-end">
                        <v-progress-circular
                            :rotate="-90"
                            :size="110"
                            :width="8"
                            :value="lesson.progress"
                            :color="progress(lesson.progress)"
                            class="roma-progress"
                        >
                            <v-avatar class="roma-card__avatar-card">
                                <img
                                    src="@/assets/images/image_card.png"
                                    alt="John"
                                />
                            </v-avatar>
                        </v-progress-circular>
                    </v-col>
                </v-row>
                <!-- edit btn -->
                <v-row no-gutters="">
                    <v-col class="text-center">
                        <!--<v-btn
                            class="text-capitalize btn-edit"
                            text
                            :to="{
                                name: 'UpdateLesson',
                                params: { id: lesson.lessonId }
                            }"
                        >
                            editar clase
                        </v-btn>-->
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>

    <!-- list mode -->
    <v-card v-else class="roma-card-inline d-flex align-center">
        <!-- desktop -->
        <v-row
            no-gutters
            class="d-none d-md-flex align-center justify-space-between"
        >
            <!-- code  -->
            <v-col cols="12">
                <span class="roma-card-inline__sub-header-code">{{
                    lesson.code
                }}</span>
            </v-col>
            <!-- title -->
            <v-col cols="auto" md="3" lg="auto">
                <router-link
                    :to="{
                        name: 'LessonDetail',
                        params: { id: lesson.lessonId }
                    }"
                >
                    <h2
                        class="roma-card-inline__title text-truncate"
                        :title="lesson.title"
                    >
                        {{ lesson.title }}
                    </h2>
                </router-link>
            </v-col>
            <!-- EN DESARROLLO -->
            <v-col cols="auto">
                <v-container>
                    <v-row no-gutters="" class="align-center">
                        <v-col cols="auto">
                            <span
                                :class="
                                    'roma-card-inline__state ' +
                                        (lesson.basicState == 'ACTIVO'
                                            ? 'green--text'
                                            : 'red--text')
                                "
                            >
                                {{
                                    lesson.basicState == "ACTIVO"
                                        ? "ACTIVA"
                                        : "INACTIVA "
                                }}
                            </span>

                            <span
                                v-if="lesson.state == 'PUBLICADO' || lesson.state == 'CERRADO'"
                                class="roma-card-inline__state"
                            >
                                {{ lesson.state == "PUBLICADO" ? "PUBLICADA" : '' }} 

                                {{ lesson.state == "CERRADO" ? "FINALIZADA" : '' }}
                                
                            </span>

                            <span
                                v-if="lesson.editState == 'EN_EDICION' || lesson.editState == 'LISTO'"
                                class="roma-card-inline__edit_state"
                            >
                                {{ lesson.editState == "EN_EDICION" ? "EDICION" : '' }} 

                                {{ lesson.editState == "LISTO" ? "LISTA" : '' }}
                                
                            </span>
                            
                            <span class="roma-card-inline__grade">{{
                                lesson.section.nameAndCategoryName
                            }}</span>
                        </v-col>
                        <v-col cols="auto" class="middle">
                            <p class="roma-card-inline__header text-capitalize">
                                {{ parserTitleSubject }}
                            </p>
                        </v-col>
                        <!-- Unidad pie -->
                        <v-col cols="auto" class="middle">
                            <span class="roma-card-inline__sub-header mx-4">{{
                                lesson.unit.name
                            }}</span>
                            <span v-if="lesson.pie">Pie</span>
                        </v-col>

                        <!-- progress Number -->
                        <!-- <v-col cols="auto" class="middle">
                            <span class="roma-card-inline__progress mx-6"
                                >{{ getProgressNumber }}%</span
                            >
                        </v-col> -->

                        <!-- date state -->
                        <v-col cols="auto" class="middle">
                            <!-- <span class="roma-card-inline__date">{{
                                parseDate
                            }}</span> -->
                            <!-- <router-link
                                :to="{
                                    name: 'UpdateLesson',
                                    params: { id: lesson.lessonId }
                                }"
                            >
                                <span class="ml-2"> {{ getState }}</span>
                            </router-link> -->
                        </v-col>
                        <v-col cols="auto" class="middle">
                            <RomaOptionsDropdown :options="dropDownOptions" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <!-- responsive -->
        <v-row no-gutters class="d-flex d-md-none">
            <v-col class="" sm="6">
                <v-container>
                    <v-row no-gutters>
                        <v-col cols="auto">
                            <span class="roma-card-inline__header">{{
                                parserTitleSubject
                            }}</span></v-col
                        >
                        <v-col>
                            <span class="roma-card-inline__grade">{{
                                lesson.section.nameAndCategoryName
                            }}</span>
                            <span
                                :class="
                                    'roma-card__state ' +
                                        (lesson.basicState == 'ACTIVO'
                                            ? 'green--text'
                                            : 'red--text')
                                "
                            >
                                {{
                                    lesson.basicState == "ACTIVO"
                                        ? "ACTIVA"
                                        : "INACTIVA "
                                }}
                            </span>

                            <span
                                v-if="lesson.state == 'PUBLICADO' || lesson.state == 'CERRADO'"
                                class="roma-card__lesson_state"
                            >
                                {{ lesson.state == "PUBLICADO" ? "PUBLICADA" : '' }} 

                                {{ lesson.state == "CERRADO" ? "FINALIZADA" : '' }}
                                
                            </span>

                            <span
                                v-if="lesson.editState == 'EN_EDICION' || lesson.editState == 'LISTO'"
                                class="roma-card__lesson_edit_state"
                            >
                                {{ lesson.editState == "EN_EDICION" ? "EDICION" : '' }} 

                                {{ lesson.editState == "LISTO" ? "LISTA" : '' }}
                                
                            </span>
                        </v-col>
                    </v-row>

                    <!-- unidad -->
                    <v-row no-gutters>
                        <v-col>
                            <span class="roma-card-inline__sub-header">{{
                                lesson.unit.name
                            }}</span>
                        </v-col>
                    </v-row>

                    <!-- codigo -->
                    <v-row no-gutters>
                        <v-col>
                            <span class="roma-card-inline__sub-header-code">{{
                                lesson.code
                            }}</span>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
            <v-col class="" cols="auto" sm="6">
                <v-container>
                    <!-- <v-row no-gutters="">
                        <v-col class="text-right">
                            <span class="roma-card-inline__date d-block">{{
                                parseDate
                            }}</span></v-col
                        >
                    </v-row>
                    <v-row>
                        <v-col class="text-right">
                            <span class="roma-card-inline__progress d-block"
                                >60%</span
                            >
                        </v-col>
                    </v-row> -->
                </v-container>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex align-center">
                <v-container class="py-0">
                    <!-- título -->
                    <v-row no-gutters>
                        <router-link
                            :to="{
                                name: 'LessonDetail',
                                params: { id: lesson.lessonId }
                            }"
                        >
                            <!-- title -->
                            <div>
                                <span
                                    class="cardTitle--text font-weight-regular roma-card-inline__title mb-3"
                                    :title="lesson.title"
                                    >{{ lesson.title }}</span
                                >
                            </div>
                        </router-link>
                    </v-row>
                </v-container>
            </v-col>
            <!-- <v-col cols="12" sm="6">
                <v-container class="py-0">
                    <v-row no-gutters="">
                        <v-col class="text-right">
                            <v-btn icon fab small class="">
                                <v-icon>icon-download</v-icon>
                            </v-btn></v-col
                        >
                    </v-row>
                </v-container>
            </v-col> -->
        </v-row>
    </v-card>
</template>
<script>
import RomaOptionsDropdown from "@/components/commons/RomaOptionsDropdown";
import { mapActions } from "vuex";
import Vue from 'vue';
import VuetifyConfirm from 'vuetify-confirm';
import Vuetify from "vuetify/lib";
Vue.use(Vuetify);
const vuetify = new Vuetify({theme:{}});
Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: 'Aceptar',
  buttonFalseText: 'Cancelar',
  color: 'warning',
  icon: '',
  title: '',
  width: 350,
  property: '$confirm'
})

export default {
    props: {
        lesson: {
            type: Object
        },
        listMode: {
            type: Boolean
        }
    },
    components: {
        RomaOptionsDropdown
    },
    data() {
        return {
            value: 50,
            options: [
                {
                    title: this.$vuetify.lang.t("Ver Clase"),
                    icon: "mdi-checkbox-blank-circle",
                    status: true,
                    action: () => {
                        console.log("Ver Clase");                        
                        this.$router.push({
                            name: "LessonDetail",
                            params: { id: this.lesson.lessonId }
                        });
                    }
                },
                {
                    // 5
                    title: this.$vuetify.lang.t("Publicar"),
                    icon: "mdi-checkbox-blank-circle",
                    status: true,
                    action: () => {
                        console.log("Publicando Clase");
                        this.publishLesson(this.lesson);
                    }
                },
                {
                    // 0
                    title: this.$vuetify.lang.t("Editar clase"),
                    icon: "mdi-checkbox-blank-circle",
                    status: true,
                    action: () => {
                        this.$router.push({
                            name: "UpdateLesson",
                            params: { id: this.lesson.lessonId }
                        });
                    }
                },
                {
                    // 2
                    title: this.$vuetify.lang.t("Activar"),
                    icon: "mdi-checkbox-blank-circle",
                    status: this.lesson.basicState === 'INACTIVO' ? true : false,
                    action: () => {
                        console.info("activando");
                        this.activateLesson(this.lesson.lessonId);
                    }
                },
                {
                    // 3
                    title: this.$vuetify.lang.t("Inactivar"),
                    icon: "mdi-checkbox-blank-circle",
                    status: this.lesson.basicState === 'ACTIVO' ? true:false,
                    action: () => {
                        console.info("inactivando");
                        this.inactivateLesson(this.lesson.lessonId);
                    }
                },
                {
                    // 4
                    title: this.$vuetify.lang.t("Eliminar"),
                    icon: "mdi-checkbox-blank-circle",
                    status: true,
                    action: () => {

                    this.$confirm('¿está seguro de eliminar esta clase?', { title: 'Confirmación', buttonTrueText: 'Aceptar', buttonFalseText: 'Cancelar'}).then(res => {

                     if(res){
                        this.deleteLesson(this.lesson.lessonId);
                     }

                     });

                    }
                },
                {
                    // 1
                    title: this.$vuetify.lang.t("Finalizar Clase"),
                    icon: "mdi-checkbox-blank-circle",
                    status: true,
                    action: () => {
                        console.info("cerrando");
                        this.closeLesson(this.lesson.lessonId);
                    }
                },
                {
                    // 6
                    title: this.$vuetify.lang.t("Archivar"),
                    icon: "mdi-checkbox-blank-circle",
                    status: true,
                    action: () => {
                        console.log("Archivando Clase");
                    }
                },
            ]
        };
    },
    computed: {
        dropDownOptions() {

            const options = [];

            // Ver clase
            options.push(this.options[0]);

            // Editar clase
            this.lesson.state != 'CERRADO' ? options.push(this.options[2]) : '';

            // Activar / Inactivar
            if(this.lesson.basicState == 'ACTIVO') {
                options.push(this.options[3]);
            } else if (this.lesson.basicState == 'INACTIVO') {
                options.push(this.options[2]);
            }
            // this.lesson.basicState == 'ACTIVO' ? options.push(this.options[3]) :  options.push(this.options[3]);

            // Cerrar Edicion / Publicar
            this.lesson.state == 'PUBLICADO' ? '': options.push(this.options[1]);

            // Eliminar
            options.push(this.options[4]);

            options.push(this.options[5]); 

            // Archivar
            options.push(this.options[6]);

            return options;
        },
        gridLesson() {
            return this.$store.getters.getGridColumnLesson;
        },
        parseDate() {
            // const d = new Date(this.lesson.date);
            // let month = String(d.getMonth() + 1);
            // let day = String(d.getDate());
            // const year = String(d.getFullYear());

            // if (month.length < 2) month = "0" + month;
            // if (day.length < 2) day = "0" + day;

            // return `${day}/${month}/${year}`;
            const dateFormat = this.lesson.date.split(" ");
            return dateFormat[0];
        },
        getState() {
            const { editState } = this.lesson;
            return editState === "EN_EDICION" ? "Edición" : "";
        },
        parserTitleSubject() {
            const value = this.lesson.subject.name;
            return value.toLowerCase();
        },
        getProgressNumber() {
            return this.lesson.percentageCompletion === null
                ? 0
                : this.lesson.percentageCompletion;
        }
    },
    methods: {
        ...mapActions({
            actionPublishLesson: "actionPublishLesson",
            actionDeleteLesson: "actionDeleteLesson",
            actionCloseLesson: "actionCloseLesson",
            actionActivateLesson: "actionActivateLesson",
            actionInactivateLesson: "actionInactivateLesson",
            actionGetLessons: "actionGetLessons",
            toastSuccess: "toastSuccess",
            toastError: "toastError"
        }),
	    progress(value) {
	      console.log("Valor progreso: "+value);
		      if (value <= 25) {
		        this.color = "secondary";
		      } else if (value >= 26 && value <= 49) {
		        this.color = "purple";
		      } else if (value >= 50 && value <= 75) {
		        this.color = "accent";
		      } else if (value >= 76 && value <= 90) {
		        this.color = "blueMedium";
		      } else {
		        this.color = "success";
		      }
		      return this.color;
	    },
        deleteLesson(lessonId) {
            this.actionDeleteLesson(lessonId)
                .then(res => {
                    this.toastSuccess({
                        message: `Se ha eliminado la clase`
                    });

                    this.actionGetLessons({ pageNumber: 0, pageSize: 8 });
                })
                .catch(err => {
                    this.toastError({
                        message: `Error al eliminar la clase`
                    });
                });
        },
        closeLesson(lessonId) {
            this.actionCloseLesson(lessonId)
                .then(res => {
                    this.toastSuccess({
                        message: `Se ha finalizado la clase`
                    });

                    this.actionGetLessons({ pageNumber: 0, pageSize: 8 });
                })
                .catch(err => {
                    this.toastError({
                        message: `Error al finalizar la clase`
                    });
                });
        },
        activateLesson(lessonId) {
            this.actionActivateLesson(lessonId)
                .then(res => {
                    this.actionGetLessons({ pageNumber: 0, pageSize: 8 });
                    this.toastSuccess({
                        message: `Se ha activado la clase`
                    });
                })
                .catch(err => {
                    this.toastError({
                        message: `Error al activar la clase`
                    });
                });
        },
        inactivateLesson(lessonId) {
            this.actionInactivateLesson(lessonId)
                .then(res => {
                    this.actionGetLessons({ pageNumber: 0, pageSize: 8 });
                    this.toastSuccess({
                        message: `Se ha inactivado la clase`
                    });
                })
                .catch(err => {
                    this.toastError({
                        message: `Error al inactivar la clase`
                    });
                });
        },
        publishLesson(lesson) {

            if(lesson.hasActivity === false){
               this.toastError({
                        message: `No está permitido publicar clases sin actividades`
                });
                return;
            }

            this.actionPublishLesson(lesson.lessonId)
                .then(res => {
                    this.actionGetLessons({ pageNumber: 0, pageSize: 8 });
                    this.toastSuccess({
                        message: `Se ha publicado la clase`
                    });
                })
                .catch(err => {
                    this.toastError({
                        message: `Error al publicar la clase`
                    });
                });
        }
    },
    filters: {
        capitalize(value) {
            if (!value) return "";
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    }
};
</script>
<style lang="scss">
$fixed-size: 3px;
.roma-card {
    .dropdown-wrapper {
        position: relative;
        .card-dropdown {
            top: 0;
            left: 50%;
            transform: translate(-50%, -50%);
            position: absolute;
        }
    }
    .btn-edit {
        .v-btn__content {
            font-size: 14px;
        }
    }
    &__custom-container {
        display: grid;
        align-items: baseline;
        grid-template-rows: max-content max-content 1fr max-content;
    }
    &__state {
        margin-left: 6px;
        border-radius: 50px;
        padding: 8px;
        width: 32px;
        height: 32px;
        line-height: 10px;
        font-size: 13px;
        color: map-get($colors, "gray-dart") !important;
        background: #f5f5f5;
        position: relative;
    }

    &__lesson_state {
        margin-left: 6px;
        border-radius: 50px;
        padding: 8px;
        width: 32px;
        height: 32px;
        line-height: 10px;
        font-size: 9px;
        // color: map-get($colors, "gray-dart") !important;
        color: #ff9102;
        background: #f5f5f5;
        position: relative;
    }

    &__lesson_edit_state {
        margin-left: 6px;
        border-radius: 50px;
        padding: 8px;
        width: 32px;
        height: 32px;
        line-height: 10px;
        font-size: 9px;
        // color: map-get($colors, "gray-dart") !important;
        color: #02a2ff;
        background: #f5f5f5;
        position: relative;
    }

    .card-container-footer {
        position: absolute;
        bottom: 20px;
        left: 18px;
        right: 18px;
    }
    .loading-card {
        height: 250px;
    }
    .middle {
        margin-top: 20px;
    }
}

.roma-card-inline {
    &__state {
        margin-left: 2px;
        border-radius: 50px;
        padding: 6px 8px;
        margin-right: 10px;
        width: 28px;
        height: 28px;
        line-height: 10px;
        font-size: 14px;
        background: #f5f5f5 0 0 no-repeat padding-box;
        text-align: center;
        font-family: Cabin !important;
        letter-spacing: 0;
        color: #ff9102;
        opacity: 1;
    }

    &__edit_state {
        margin-left: 2px;
        border-radius: 50px;
        padding: 6px 8px;
        margin-right: 10px;
        width: 28px;
        height: 28px;
        line-height: 10px;
        font-size: 14px;
        background: #f5f5f5 0 0 no-repeat padding-box;
        text-align: center;
        font-family: Cabin !important;
        letter-spacing: 0;
        color: #02a2ff;
        opacity: 1;
    }
}
</style>
